import React from "react";
import propTypes from "prop-types";
import Evaporate from "evaporate";
import AWS from "aws-sdk";

class S3Upload extends React.Component {
  state = {
    evaporate: null
  };

  componentDidMount() {
    Evaporate.create({
      aws_key: process.env.REACT_APP_AWS_KEY,
      bucket: process.env.REACT_APP_AWS_BUCKET,
      awsRegion: process.env.REACT_APP_AWS_REGION,
      signerUrl: process.env.REACT_APP_BASE_URL + 's3/sign/',
      awsSignatureVersion: process.env.REACT_APP_AWS_SIGNATURE_VERSION,
      computeContentMd5: process.env.REACT_APP_AWS_COMPUTE_CONTENT_MD5,
      cryptoMd5Method: function(data) {
        return AWS.util.crypto.md5(data, "base64");
      },
      cryptoHexEncodedHash256: function(data) {
        return AWS.util.crypto.sha256(data, "hex");
      }
    }).then((evaporate) => this.setState({ evaporate }));
  }
  render() {
    const { render, pending } = this.props;
    const { evaporate } = this.state;
    return evaporate ? render(evaporate) : pending();
  }
}

S3Upload.propTypes = {
  render: propTypes.func.isRequired,
  pending: propTypes.func.isRequired
};

export default S3Upload;
